import React from 'react';
import { ComponentWrapper, Icon, Tooltip } from '@ihsm/ui-shared';
import { JobItemStatus } from 'scenes/jobs/types';
import { jobStatusCellCss } from '../../utils';

export interface JobStatusCellItemProps {
  icon?: string;
  customIconElement?: React.ReactNode | React.FC | React.ReactElement;
  errors?: string;
  status?: JobItemStatus;
}

export const JobStatusCellItem: React.FC<JobStatusCellItemProps> = ({
  children,
  customIconElement,
  icon,
  errors,
  status,
}) => {
  const { jobCellIcon, jobCellItem, jobCellText } = jobStatusCellCss({
    errors: !!errors,
    status,
  });

  return (
    <div className={jobCellItem}>
      <div className={jobCellIcon}>
        {customIconElement ? (
          <ComponentWrapper component={customIconElement} />
        ) : null}

        {icon ? <Icon source={icon} /> : null}
      </div>

      <div className={jobCellText}>
        <Tooltip dottedText tip={errors}>
          {children}
        </Tooltip>
      </div>
    </div>
  );
};
